// This file is automatically generated. Do not edit manually.

import { IsoDateString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderLineActionApi {
	export async function cancelCustomerOrderLines(args: { customerOrderLineIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/cancelCustomerOrderLines",
			method: "POST",
			data: {
				customerOrderLineIds: args.customerOrderLineIds,
			},
		});
		return response as void;
	}

	export async function rescheduleSelectedCustomerOrderLines(args: {
		customerOrderLineIds: Array<number>;
		newPlannedDeliveryDate: IsoDateString;
		updateAcquisitionObjects: boolean;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/rescheduleSelectedCustomerOrderLines",
			method: "POST",
			data: {
				customerOrderLineIds: args.customerOrderLineIds,
				newPlannedDeliveryDate: args.newPlannedDeliveryDate,
				updateAcquisitionObjects: args.updateAcquisitionObjects,
			},
		});
		return response as void;
	}

	export async function changeCustomerOrderLineDeliveredQuantity(args: {
		customerOrderLineDtos: Array<CustomerOrderLineActionApi_CustomerOrderLineDirectDeliverDto>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/changeCustomerOrderLineDeliveredQuantity",
			method: "POST",
			data: {
				customerOrderLineDtos: args.customerOrderLineDtos,
			},
		});
		return response as void;
	}

	export async function releaseCustomerOrderLines(args: { customerOrderLineIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/releaseCustomerOrderLines",
			method: "POST",
			data: {
				customerOrderLineIds: args.customerOrderLineIds,
			},
		});
		return response as void;
	}

	export async function revertReleaseCustomerOrderLines(args: {
		customerOrderLineIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/revertReleaseCustomerOrderLines",
			method: "POST",
			data: {
				customerOrderLineIds: args.customerOrderLineIds,
			},
		});
		return response as void;
	}

	export async function unpackCustomerOrderLineConfiguration(args: { customerOrderLineId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/unpackCustomerOrderLineConfiguration",
			method: "POST",
			data: {
				customerOrderLineId: args.customerOrderLineId,
			},
		});
		return response as void;
	}

	export async function revertUnpackCustomerOrderLineConfiguration(args: {
		customerOrderLineId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/revertUnpackCustomerOrderLineConfiguration",
			method: "POST",
			data: {
				customerOrderLineId: args.customerOrderLineId,
			},
		});
		return response as void;
	}

	export async function markCustomerOrderLineToFullyDelivered(args: { customerOrderLineId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/markCustomerOrderLineToFullyDelivered",
			method: "POST",
			data: {
				customerOrderLineId: args.customerOrderLineId,
			},
		});
		return response as void;
	}

	export async function revertMarkCustomerOrderLineToFullyDelivered(args: {
		customerOrderLineId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/revertMarkCustomerOrderLineToFullyDelivered",
			method: "POST",
			data: {
				customerOrderLineId: args.customerOrderLineId,
			},
		});
		return response as void;
	}
}

export interface CustomerOrderLineActionApi_CustomerOrderLineDirectDeliverDto {
	amount: number;
	customerOrderLineId: number;
}
